// import { h } from 'preact';
import { useReducer } from 'preact/hooks';
import { init } from 'smolcart.js';
import { updateCartCount } from '../utils/cartManager';

/**
 *
 * this hook initiates a state manager for a curbside
 * order / order with additional options
 *
 * @param {initialOptions, baseProduct} options a collection of the needed options
 */
const useCurbsiderReducer = ({ initialOptions, baseProduct }) => {
  const reducer = (currOptions, action) => {
    switch (action.type) {
      case 'ADD_AO':
        return {
          ...currOptions,
          unselected: currOptions.unselected.filter(
            (opt) => opt.id !== action.payload.id
          ),
          selected: [action.payload, ...currOptions.selected],
          activeAddons: [
            action.payload.variants[0],
            ...currOptions.activeAddons,
          ],
        };
      case 'REMOVE_AO':
        return {
          ...currOptions,
          unselected: [action.payload, ...currOptions.unselected],
          selected: currOptions.selected.filter(
            (opt) => opt.id !== action.payload.id
          ),
          activeAddons: currOptions.activeAddons.filter((addon) => {
            const itemName = action.payload.title;
            const variantName = addon.name;
            return !variantName.includes(itemName);
          }),
        };
      case 'CHANGE_AO':
        const addonName = action.payload.name.split(' ')[0];
        const indexOfAo = currOptions.activeAddons.findIndex((addon) =>
          addon.name.includes(addonName)
        );
        const newActiveAddons = currOptions.activeAddons;
        newActiveAddons[indexOfAo] = action.payload;
        return {
          ...currOptions,
          activeAddons: newActiveAddons,
        };
      case 'CHANGE_VARIANT':
        return {
          ...currOptions,
          activeVariant: action.payload,
        };
      case 'UPDATE_TOTAL':
        const newTotal = calculatTotalCost(currOptions);
        // updates the main/non-preact section of the page
        const priceTagEl = document.querySelector('[data-regular-price]');
        if (priceTagEl) priceTagEl.textContent = `$${newTotal}`;
        return {
          ...currOptions,
          itemTotal: newTotal,
        };
      case 'ADD_TO_CART':
        const cart = init();
        const itemNotes = document.querySelector('#product-notes');
        cart.getCart().then((data) => {
          const itemNumber = data.item_count + 1;
          const currentCart = [
            ...currOptions.activeAddons.map((addon) => {
              return {
                id: addon.id,
                quantity: 1,
                properties: {
                  for: `${baseProduct.title} #${itemNumber}`,
                },
              };
            }),
            {
              id: currOptions.activeVariant.id,
              quantity: 1,
              properties: {
                '#': `${itemNumber}`,
                notes: `${itemNotes ? itemNotes.value : 'none'}`,
              },
            },
          ];
          cart.addItems(currentCart).then(() => {
            updateCartCount();
          });
        });
        return {
          ...currOptions,
          hasAddedToCart: true,
        };
    }
  };

  const calculatTotalCost = (state) => {
    const { activeVariant, activeAddons } = state;
    const activeAddonTotal =
      activeAddons.length > 0
        ? activeAddons
            .map((addon) => addon.price)
            .reduce((acc, curr) => {
              return acc + curr;
            })
        : 0;
    const sum = ((activeVariant.price + activeAddonTotal) / 100).toFixed(2);
    return sum;
  };

  const [optionState, dispatch] = useReducer(reducer, {
    unselected: initialOptions,
    selected: [],
    activeVariant: baseProduct.variants[0],
    activeAddons: [],
    itemTotal: (baseProduct.price / 100).toFixed(2),
    hasAddedToCart: false,
  });

  return [optionState, dispatch];
};

export default useCurbsiderReducer;
